/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Costs
 */
export interface Costs {
    /**
     * 
     * @type {string}
     * @memberof Costs
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof Costs
     */
    totalCost: number;
}

export function CostsFromJSON(json: any): Costs {
    return CostsFromJSONTyped(json, false);
}

export function CostsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Costs {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'totalCost': json['total_cost'],
    };
}

export function CostsToJSON(value?: Costs | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'total_cost': value.totalCost,
    };
}


